'use strict';

module.exports = {
  bundle: 'bundle',
  template: 'template',
  workpackage: 'workpackage',
};
